import React from 'react';
import { H5, P1, TextLink } from 'pfm-ui-components';
import { DISCLAIMER_LINK } from '../../../constants/common';

const DisclaimerModalInfo = () => {
  return (
    <React.Fragment>
      <H5>Notice</H5>
      <P1>
        Please read these terms and conditions carefully. By accessing this site and any pages thereof, you agree to be
        bound by the terms and conditions below. If you do not agree to the terms and conditions below, do not access
        this site or any pages thereof.
      </P1>
      <H5>Copyight (c) Axis Bank Ltd. 2001. All Rights Reserved</H5>
      <P1>
        Copyright in the pages and in the screens displaying the pages, and in the information and material therein and
        in their arrangement, is owned by Axis Bank Limited, unless otherwise indicated.
      </P1>
      <H5>Trademarks</H5>
      <P1>
        Axis Bank Limited and the logo are registered trademarks and service marks. Axis Bank Limited may also claim
        trademark and service mark rights in other marks contained in the pages.
      </P1>
      <H5>Use of Information and Materials</H5>
      <P1>
        The information and materials contained in these pages - and the terms, conditions, and descriptions that appear
        - are subject to change. Not all products and services are available in all geographic areas. Your eligibility
        for particular products and services is subject to final Axis Bank Limited determination and acceptance.
        Investment products are not obligations of or guaranteed by Axis Bank Limited. Investment services are not bank
        deposits or insured by any entity, and are subject to investment risks, including possible loss of the principal
        amount invested.
      </P1>
      <H5>No Warranty</H5>
      <P1>
        The information and materials contained in this site, including text, graphics, links or other items - are
        provided "as is," "as available". Axis Bank Limited does not warrant the accuracy, adequacy or completeness of
        this information and materials and expressly disclaims liability for errors or omissions in this information and
        materials. No warranty of any kind, implied, express or statutory, including but not limited to the warranties
        of non-infringement of third party rights, title, merchantability, fitness for a particular purpose and freedom
        from computer virus, is given in conjunction with the information and materials.
      </P1>
      <H5>Limitation of Liability</H5>
      <P1>
        In no event will Axis Bank Limited be liable for any damages, including without limitation direct or indirect,
        special, incidental, or consequential damages, losses or expenses arising in connection with this site or use
        thereof or inability to use by any party, or in connection with any failure of performance, error, omission,
        interruption, defect, delay in operation or transmission, computer virus or line or system failure, even if Axis
        Bank limited, or representatives thereof, are advised of the possibility of such damages, losses or expenses.
        Hyperlinks to other internet resources are at your own risk; the content, accuracy, opinions expressed, and
        other links provided by these resources are not investigated, verified, monitored, or endorsed by Axis Bank
        Limited.
      </P1>
      <H5>Submissions</H5>
      <P1>
        All information submitted to Axis Bank Limited via this site shall be deemed and remain the property of Axis
        Bank Limited. Axis Bank Limited shall be free to use, for any purpose, any ideas, concepts, know-how or
        techniques contained in information a visitor to this site provides Axis Bank Limited through this site. Axis
        Bank Limited shall not be subject to any obligations of confidentiality regarding submitted information except
        as agreed by the Axis Bank Limited, entity having the direct customer relationship or as otherwise specifically
        agreed or required by law.
      </P1>
      <H5>Code of Bank's Commitment</H5>
      <P1>
        <TextLink href={DISCLAIMER_LINK} target="_blank" tabIndex={0}>
          Banking Codes &amp; Standards Board of India (BCSBI) Codes
        </TextLink>
      </P1>
      <H5>EMI Amounts</H5>
      <P1>
        Please note that this amort schedule provides only approximate principal and interest amounts, as it is
        calculated on an assumption of 360 days per year. Kindly do not consider this to be the final schedule, as the
        actual EMI amounts may vary basis actual number of days in a month and 365 days in a year. <br />
        <br />
        {/* This Code is in compliance with Clause 49 of the Listing Agreements relating to Corporate Governance. */}
      </P1>
      <H5>Additional Disclaimer</H5>
      <P1>
        This e-mail is confidential. It may also be legally privileged. If you are not the addressee you may not copy,
        forward, disclose or use any part of it. Internet communications cannot be guaranteed to be timely secure, error
        or virus-free. The sender does not accept liability for any errors or omissions. We maintain strict security
        standards and procedures to prevent unauthorized access to information about you. Axis Bank will never contact
        you by email or otherwise to ask you to validate personal information such as your user ID or password. The
        contents of this mail are solely for informational purpose. Nothing contained herein shall constitute or be
        deemed to constitute an advice, invitation or solicitation to purchase any products/ services of Axis Bank. Axis
        Bank does not accept any responsibility for any errors whether caused by negligence or otherwise or for any loss
        or damage incurred by anyone in reliance on anything set out herein. The use of this information is subject to
        the terms and conditions as specified by Axis Bank at{' '}
        <TextLink href="https://www.axisbank.com/" tabIndex={0}>
          www.axisbank.com
        </TextLink>
        .You are receiving this email as information regarding our products and services. The use of this information is
        subject to the terms and conditions governing to such respective products, services and offers as referred
        herein above and specified by Axis Bank / third party from time to time. The images depicted herein are for
        illustrative purposes only. The information set out herein may be subject to updates, completion, revision,
        verification and amendment and such information may change materially.
        <br />
        If you have received this message in error, please delete it .Axis Bank does not accept any responsibility for
        any errors whether caused by negligence or otherwise or for any loss or damage incurred by anyone in reliance on
        anything set out in this document. Axis Bank shall not be responsible for any loss, damage or other harm that
        may result from the use of third party's products / services.
        <br /> <br /> This id is used by the bank only for communication and promotional emails. Please do not reply to
        this mail as it is computer generated. For any further queries or information, visit{' '}
        <TextLink href="https://www.axisbank.com/" tabIndex={0}>
          www.axisbank.com
        </TextLink>
        . You may, at any time, choose not to receive email marketing literature / information about our products and
        services by clicking on "unsubscribe"..
        <br />
        <br />
        <H5>Mutual Funds Disclaimer</H5>
        <br />
        Mutual Fund investments are subject to market risk, read all scheme related documents carefully. Axis Bank Ltd
        is acting as an AMFI registered MF Distributor (ARN code: ARN-0019). Visit Axis Bank Internet / Mobile banking
        platforms, MF scheme details page for more information. Purchase of Mutual Funds by Axis Bank’s customer is
        purely voluntary and not linked to availment of any other facility from the Bank. <br /> <br />
        Axis Bank or any of its affiliates/ group companies shall not be answerable or responsible in any way for any
        kind of loss or damage that may arise to any person due to any kind of error in the information contained in
        this document or otherwise.
      </P1>
      <P1>
        <br />
        Please note that we are using your details available with us (PAN and full name) to share with the KRAs (KYC
        registration agencies) for MF KYC check. The data is also shared with AMCs (Asset Management Companies who
        manage your investments in mutual funds) as they need the information for onboarding you as a customer. There is
        a possibility of name mismatch between your details stored in the bank and what is available with the KRAs. In
        such scenarios, the AMC may reject your transaction. Axis Bank will not liable for such rejection cases.
      </P1>
      <br />
      You can refer the scheme documents Scheme Information Document(SID) / Key Information Memorandum (KIM) / Statement
      of Additional Information (SAI) for the respective AMC's by clicking on the below links <br />
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://mutualfund.adityabirlacapital.com/resources/forms/"
        tabIndex={0}
      >
        Aditya Birla Sun Life Mutual fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" rel="noopener noreferrer" href="https://www.axismf.com/downloads" tabIndex={0}>
        {' '}
        Axis Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.bajajamc.com/downloads?sid-kim-products-forms"
        tabIndex={0}
      >
        {' '}
        Bajaj Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        href="https://www.canararobeco.com/forms-downloads/forms-and-information-documents/forms/application-form"
        tabIndex={0}
      >
        Canara Robeco Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.dspim.com/investor-centre/download" tabIndex={0}>
        DSP Blackrock Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        href="https://www.edelweissmf.com/downloads/scheme-information-document-funds"
        tabIndex={0}
      >
        Edelweiss Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        href="https://www.franklintempletonindia.com/investor/downloads/fund-documents#"
        tabIndex={0}
      >
        Franklin Templeton Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.hdfcfund.com/information/online-services-investors" tabIndex={0}>
        HDFC Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        href="https://www.assetmanagement.hsbc.co.in/en/mutual-funds/investor-resources"
        tabIndex={0}
      >
        HSBC Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.icicipruamc.com/Downloads/sid-mutual-fund.aspx" tabIndex={0}>
        ICICI Prudential Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.idfcmf.com/download-centre.aspx?tab=sid" tabIndex={0}>
        Bandhan Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://invescomutualfund.com/literature-and-form?tab=Forms" tabIndex={0}>
        Invesco India Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.kotakmf.com/Information/forms-and-downloads" tabIndex={0}>
        Kotak Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.licmf.com/sid-kim-sai" tabIndex={0}>
        LIC Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.miraeassetmf.co.in/downloads/forms" tabIndex={0}>
        Mirae Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.motilaloswalmf.com/downloads/mutual-fund" tabIndex={0}>
        Motilal Oswal Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        href="https://mf.nipponindiaim.com/investor-service/downloads/scheme-information-document"
        tabIndex={0}
      >
        Nippon India Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.sbimf.com/en-us/offer-document-sid-kim" tabIndex={0}>
        SBI Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.sundarammutual.com/Downloads" tabIndex={0}>
        Sundaram Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="http://www.tatamutualfund.com/downloads/scheme-information-document" tabIndex={0}>
        TATA Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" href="https://www.utimf.com/forms-and-downloads/" tabIndex={0}>
        UTI Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" rel="noopener noreferrer" href="https://mf.whiteoakamc.com/downloads" tabIndex={0}>
        WHITEOAK Capital Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.mahindramanulife.com/downloads#SID/SAI"
        tabIndex={0}
      >
        Mahindra Manulife Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.360.one/asset-management/mutualfund/"
        tabIndex={0}
      >
        360 ONE Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.unionmf.com/about-us/downloads#!#sidsainotice"
        tabIndex={0}
      >
        Union Mutual Fund
      </TextLink>{' '}
      <br />
      <TextLink target="_blank" rel="noopener noreferrer" href="https://amc.ppfas.com/downloads/index.php" tabIndex={0}>
        PPFAS Mutual Fund
      </TextLink>{' '}
      <br />
      <br />
      <TextLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.amfiindia.com/downloads/revised-code-conduct-of-inter-mf"
        tabIndex={0}
      >
        AMFI Code of Conduct
      </TextLink>{' '}
      <br />
      {/* This Code is in compliance with Clause 49 of the Listing Agreements relating to Corporate Governance. */}
    </React.Fragment>
  );
};

export default DisclaimerModalInfo;
